import { gql } from '@apollo/client'

export type QueryVars = {
  customerId: string
  squad: Squad
  limit: number
  offset: number
}

export type Squad = 'a' | 'b' | 'c' | 'd' | 'e' | 'g' | 'i' | 'j' | 'k' | 'l'

export type ExecutiveBySquadResponse = {
  userId: string
  skillLevel: number | null
  fullName: string
}

export type Response = {
  getExecutivesBySquad: {
    total: number
    offset: number
    results: ExecutiveBySquadResponse[]
  }
}

const query = gql`
  query ($customerId: String!, $squad: String!, $limit: Int!, $offset: Int!) {
    getExecutivesBySquad(
      customerId: $customerId
      squad: $squad
      limit: $limit
      offset: $offset
    ) {
      total
      offset
      results {
        userId
        skillLevel
        fullName
      }
    }
  }
`

export default query
